<template>
  <div>
    <kst-output print-mode field="ClientID" :data="details" :catalog="Catalog"/>
    <kst-output print-mode field="ClientAddress" :data="details" :catalog="Catalog"/>
    <kst-output print-mode field="WarehouseID" :data="details" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../RinvCatalog.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>